import { Component, OnInit, ViewChild } from '@angular/core';
import { TableHistoryQrisComponent } from './components/table-history-qris/table-history-qris.component';

import { BaseService } from 'src/app/services/base.service';
import { GENERATE_QRIS, OPTION_QRIS } from 'src/app/constants/endpoint.const';
import { GeneratedQrisResponse, OptionQrisResponse } from 'src/app/types/response/qrisly.response.type';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-generate-qris',
  templateUrl: './generate-qris.component.html',
  styleUrl: './generate-qris.component.scss'
})
export class GenerateQrisComponent implements OnInit {
  @ViewChild(TableHistoryQrisComponent) tableHistoryQris!: TableHistoryQrisComponent;
  loading: boolean = true;
  amount: any;
  selectedQRIS: number | null = null;
  qrisList: OptionQrisResponse[] = [];

  isGenerated: boolean = false;
  generatedData: GeneratedQrisResponse | null = null;
  isInsufficientBalance: boolean = false;

  constructor(
    private baseService: BaseService,
    private message: NzMessageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getListOptions();
  }

  getListOptions() {
    this.baseService.getData(OPTION_QRIS).subscribe({
      next: (res: { data: OptionQrisResponse[] }) => {
        this.qrisList = res.data;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    })
  }

  generateQris() {
    if (!this.amount || !this.selectedQRIS) return;

    const payload = {
      amount: Number(this.amount),
      qris_id: this.selectedQRIS,
      output_type: 'string',
      is_unique_amount: true,

    }
    this.baseService.postData(GENERATE_QRIS, payload).subscribe({
      next: (res: { data: GeneratedQrisResponse }) => {
        this.isGenerated = true;
        this.generatedData = res.data;
        this.tableHistoryQris.getHistoryQris();
      },
      error: (err) => {
        if (err.error.meta.message === 'insufficient balance') {
          this.isInsufficientBalance = true;
        }
        this.message.create('error', err.error.meta.message);
      }
    })
  }

  onlyNumber(event: KeyboardEvent) {
    const charCode = event.key;
    const inputElement = event.target as HTMLInputElement;

    // Allow navigation and deletion keys
    if (['Backspace', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(charCode)) {
      return;
    }

    // Only allow digits
    if (!/^\d$/.test(charCode)) {
      event.preventDefault();
      return;
    }

    // Prevent leading zero if first character
    if (charCode === '0' && inputElement.selectionStart === 0) {
      event.preventDefault();
    }
  }

  onAmountChange(value: any) {
    if (value) {
      // Remove any non-numeric characters and leading zeros
      const sanitizedValue = value.toString().replace(/[^0-9]/g, '').replace(/^0+/, '');
      if (this.amount !== sanitizedValue) {
        this.amount = sanitizedValue;
      }
    } else {
      this.amount = null;
    }
  }

  handleTopUp() {
    this.router.navigate(['/finance/balance']);
    this.isInsufficientBalance = false;
  }
}
